import React from "react";
import WhatsAppButton from "./WhatsAppButton";
import { buildWA } from "../data/catalog";

const FloatingWA = () => {
  return (
    <div
      data-testid="floating-wa"
      className="fixed bottom-5 right-5 z-40"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl pulse-glow" />
        <WhatsAppButton
          testId="floating-wa-button"
          href={buildWA("Saya ingin info produk DIGIFRIEND", "")}
          className="!bg-[#25D366] hover:!bg-[#1ebe5b] !text-white !shadow-2xl"
        >
          Chat Admin
        </WhatsAppButton>
      </div>
    </div>
  );
};

export default FloatingWA;
